import React, { useState, useEffect } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import { Box, Flex, Text, Button, Group, Pagination, TextInput, Modal, Badge, Drawer } from '@mantine/core' 
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import { IconPlus } from '@tabler/icons-react'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { getAllSupplierList, deleteSupplier } from '../../../../services/supplier'
import LoadingData from '../../../../component/ui/LoadingData'
import NoData from '../../../../component/ui/NoData'
import TableSupplier from '../../../../component/pages/Supplier/TableSupplier'
import FormSupplier from '../../../../component/pages/Supplier/FormSupplier'
import FormFilterSupplier from '../../../../component/pages/Supplier/FormFilterSupplier'
import { modalDeleteData } from '../../../../component/ui/Prompt/modalDeleteData'
import { notificationError } from '../../../../component/ui/Notifications'
import { useDebouncedCallback } from '@mantine/hooks'

const defaultParameter = {
  'page[num]': 1,
  'page[limit]': 10,
  sort: '-id',
  include: 'categories,supplier,source,variations,images,users,country,province,city,district,settings,discount_cities',
}

const labelTable = [
  {
    label: 'ID',
    width: 30
  },
  {
    label: 'Supplier Name',
    width: 200
  },
  {
    label: 'Country Origin',
    width: 100
  },
  {
    label: 'Address',
    width: 200
  },
  {
    label: 'Province',
    width: 100
  },
  {
    label: 'City',
    width: 100
  },
  {
    label: 'Subdistrict',
    width: 100
  },
  {
    label: 'Total Product',
    width: 100
  },
  {
    label: 'Website',
    width: 200
  },
  {
    label: 'Status',
    width: 100
  },
  {
    label: 'Action',
    width: 50
  },
]

const SupplierList = () => {
  const dispatch = useDispatch()
  const [params, setParams] = useState(defaultParameter)
  const [supplierList, setSupplierList] = useState([])
  const [totalData, setTotalData] = useState(0)
  const [loading, setLoading] = useState(true)
  const [openModalForm, setOpenModalForm] = useState(false)
  const [detailData, setDetailData] = useState(null)
  const [openModalFilter, setOpenModalFilter] = useState(false)

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Product',
      route: null
    },
    { 
      label: 'Supplier',
      route: null
    },
  ]

  const handleGetSupplierList = useDebouncedCallback(async () => {
    setLoading(true)
    try {
      const response = await getAllSupplierList(params)
      if (response.success) {
        const dataSupplier = response.data
        const pickIncludedCountry = response.included.country || []
        const pickIncludedProvince = response.included.province || []
        const pickIncludedCity = response.included.city || []
        const pickIncludedDistrict = response.included.district || []
        const pickIncludedSetting = response.included.settings || []
        const pickIncludedUsers = response.included.users || []
        const pickIncludedDiscountCity = response.included.discount_cities || []

        const countData = response.meta.pagination.total

        const getDataCountry = (countryId, included) => {
          let data = null
          const findCountry = included[countryId]
          if (findCountry) {
            data = {
              id: findCountry.attributes.id,
              name: findCountry.attributes.name
            }
          }
          return data
        }

        const getDataProvince = (provinceId, included) => {
          let data = null
          const findProvince = included[provinceId]
          if (findProvince) {
            data = {
              id: findProvince.attributes.id,
              name: findProvince.attributes.name
            }
          }
          return data
        }

        const getDataCity = (cityId, included) => {
          let data = null
          const findCity = included[cityId]
          if (findCity) {
            data = {
              id: findCity.attributes.id,
              name: findCity.attributes.name
            }
          }
          return data
        }

        const getDataDistrict = (district, included) => {
          let data = null
          const findDistrict = included[district]
          if (findDistrict) {
            data = {
              id: findDistrict.attributes.id,
              name: findDistrict.attributes.name
            }
          }
          return data
        }

        const getDataSettings = (dataSettings, included) => {
          let data = []
          const remapData = dataSettings.map((val) => {
            return {
              ...included[val.id].attributes
            }
          })
          if (remapData.length > 0) {
            data = remapData
          }
          return data
        }

        const getDataUsers = (dataUser, included) => {
          let data = []
          const remapData = dataUser.map((val) => {
            return {
              id: included[val.id].attributes.id,
              name: included[val.id].attributes.name,
              email: included[val.id].attributes.email,
              phone: included[val.id].attributes.phone,
              type: included[val.id].attributes.pivot.supplier_type
            }
          })
          if (remapData.length > 0) {
            data = remapData
          }
          return data
        }

        const getDicountCity = (dataDiscountCity, included) => {
          let data = []
          const remapData = dataDiscountCity.map((val) => {
            return {
              value: `${included[val.id].attributes.id}`,
              label: included[val.id].attributes.name
            }
          })
          if (remapData.length > 0) {
            data = remapData
          }
          return data
        }

        const remapData = dataSupplier.map((val) => {
          return {
            ...val.attributes,
            country: val.attributes.country_id !== null ? getDataCountry(val.attributes.country_id, pickIncludedCountry) : null,
            province: val.attributes.province_id !== null ? getDataProvince(val.attributes.province_id, pickIncludedProvince) : null,
            city: val.attributes.city_id !== null ? getDataCity(val.attributes.city_id, pickIncludedCity) : null,
            district: val.attributes.district_id !== null ? getDataDistrict(val.attributes.district_id, pickIncludedDistrict) : null,
            settings: val.relationships.settings.length > 0 ? getDataSettings(val.relationships.settings, pickIncludedSetting) : [],
            users: val.relationships.users.length > 0 ? getDataUsers(val.relationships.users, pickIncludedUsers) : [],
            discount_cities: val.relationships.discount_cities.length > 0 ? getDicountCity(val.relationships.discount_cities, pickIncludedDiscountCity) : []
          }
        })

        setSupplierList(remapData)
        setTotalData(countData)
      } else {
        setSupplierList([])
        setTotalData(1)
      }
    } catch (error) {
      console.log(error)
      setSupplierList([])
      setTotalData(1)
      const errorMessage = error.response.data.message
      notificationError('Load Data Error', `${errorMessage}`)
    } finally {
      setLoading(false)
    }
  })

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch])

  useEffect(() => {
    handleGetSupplierList()
    // eslint-disable-next-line
  }, [params])

  const handleChangeFilter = (name, val) => {
    setParams((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const handleApplyFilter = (params) => {
    setParams((oldVal) => ({ ...oldVal, ...params }))
  }

  const handleChangePage = (val) => {
    // eslint-disable-next-line
    setParams((oldVal) => ({ ...oldVal, ['page[num]']: val }))
  }

  const actions = {
    edit: (val) => {
      setDetailData(val)
      setOpenModalForm(true)
    },
    delete: (val) => {
      modalDeleteData('supplier', val.id, val.name, deleteSupplier, handleGetSupplierList)
    }
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const onCloseModalForm = () => {
    setOpenModalForm(false)
    setDetailData(null)
  }

  const onCloseFormFilter = () => {
    setOpenModalFilter(false)
  }

  const mappingFilterSupplier = (parameter) => {
    if (parameter['filter[featured][is]'] || parameter['filter[country.id][is]'] || parameter['filter[active][is]']) {
      return (
        <Box>
          <Group gap='sm' align='center' mb={12}>
            {parameter['filter[featured][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Featured : {parameter['filter[featured][is]'] === 'true' ? 'Yes' : 'No'}</Badge> : ''}
            {parameter['filter[active][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Supplier : {parameter['filter[active][is]'] === 'true' ? 'Active' : 'Inactive'}</Badge> : ''}
            {parameter['filter[country.id][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Country ID : {parameter['filter[country.id][is]']}</Badge> : ''}
          </Group>
          <Group align='center' gap='sm'>
            <Button size='compact-sm' fz={11} fw='500' variant="outline" onClick={() => setOpenModalFilter(true)}>Modify Filter</Button>
            <Button size='compact-sm' fz={11} fw='500' variant="outline" onClick={() => setParams(defaultParameter)}>Clear Filter</Button>
          </Group>
        </Box>
      )
    }
  }

  return (
    <AuthLayout>
      <Box my={20}>
        <Box>
          <Flex justify='space-between' align="center" mb={30}>
            <Text className={classes.titleLayout}>Supplier</Text>
            <Group gap='sm' align='center'>
              <TextInput
                value={params['filter[name][like]']}
                placeholder='Search by name'
                onChange={(val) => {
                  handleChangeFilter('filter[name][like]', val.target.value)
                  handleChangePage(1)
                }}
                size='xs'
              />
              <Button size='xs' variant="outline" onClick={() => setOpenModalFilter(true)}>Filter</Button>
              <Button size='xs' leftSection={<IconPlus size={14} />} onClick={() => setOpenModalForm(true)}>Add Supplier</Button>
            </Group>
          </Flex>
        </Box>
        {mappingFilterSupplier(params)}
        <Box my={30}>
          {loading ? <LoadingData /> : supplierList.length > 0 ? <TableSupplier label={labelTable} data={supplierList} actionMethod={handleAction} /> : <NoData />}
        </Box>
        <Flex justify='end'>
          <Pagination size='sm' onChange={handleChangePage} value={params['page[num]']} total={totalData > 0 ? Math.ceil(totalData / params['page[limit]']) : totalData} />
        </Flex>
      </Box>
      <Drawer position='right' title='Filter Supplier' opened={openModalFilter} onClose={onCloseFormFilter} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormFilterSupplier paramSupplier={params} applyFilter={handleApplyFilter} onClose={onCloseFormFilter} />
      </Drawer>
      <Modal opened={openModalForm} onClose={onCloseModalForm} centered closeOnClickOutside={false} size='75%' title={<Text fw='Bold'>{detailData === null ? 'Add' : 'Update'} Supplier</Text>} withCloseButton={false}>
        <FormSupplier dataSupplier={detailData} onCloseModal={onCloseModalForm} reloadList={handleGetSupplierList} />
      </Modal>
    </AuthLayout>
  )
}

export default SupplierList